import { isInvalid } from '@/modules/validate';
import { loggerError } from '@/modules/logger';

import { LogModule } from '@/data/config';

/**
 * blob转成base64
 * @param {Blob} blob
 * @returns
 */
export const blobToDataURL = (blob: Blob): Promise<string | ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = function (e) {
      if (e.target?.result) {
        resolve(e.target.result);
      } else {
        reject(new Error('blobToDataURL function error'));
      }
    };
    fileReader.readAsDataURL(blob);
  });
};

/**
 * blob转成file文件
 * @param blob
 * @param fileName
 */
export function blobToFile(blob: any, fileName: string, isNewFile?: boolean): File | Blob {
  if (isInvalid(blob)) {
    return blob;
  }
  try {
    // 判断是否需要通过newFile方式创建
    if (isNewFile) {
      const file = new File([blob], fileName, { type: blob?.type ?? 'image/jpeg' });
      return file;
    }

    blob.name = fileName;
    blob.lastModifiedDate = new Date().getTime();
    return blob;
  } catch (e) {
    loggerError(e, LogModule.Image);
    return blob;
  }
}

/**
 * 判断支不支持图片类型
 * @param type
 */
export function isSupportedType(type: string): boolean {
  const regex = /^image\/(jpe?g|png|bmp|webp|bpg)$/;
  return regex.test(type);
}

/**
 * base64转blob对象
 * @param dataURI
 */
export function dataURItoBlob(dataURI: string): Blob {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }
  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {
    type: mimeString,
  });
}
